export default function (req, res, next) {
    res.setHeader("X-Version", process.env.VERSION || "dev");
    next();
}
